
eliminarOptica = function(e){
    let data = e.dataset;
    document.getElementById('eliminar_optica_nombre').innerHTML=data.nombre;
    document.getElementById('eliminar_optica_id').value=data.id;
}